import { ETypeMaterielAdductionAir } from "src/app/domain/Adduction-air/enum/type-materiel";
import { ETypePrelevementAir } from "src/app/domain/Adduction-air/enum/type-prelevement-air";
import { ELocalisationRejet } from "src/app/domain/EAU/enum/location-rejet";
import { ETypeMateriel } from "src/app/domain/EAU/enum/materiel-type";
import { EActivitySimulationType } from "src/app/domain/enums/activity-simulation-type";
import { EAPRType } from "src/app/domain/enums/APR-type";
import { EBuildingType } from "src/app/domain/enums/building-type";
import { ECardinality } from "src/app/domain/enums/cardinality";
import { EDegradationLevel } from "src/app/domain/enums/degradation-level";
import { EDustLoadType } from "src/app/domain/enums/dust-load-type";
import { EEntreeProcessType } from "src/app/domain/enums/entree-process-type";
import { EEntreeZoneType } from "src/app/domain/enums/entree-zone";
import { EEPIType } from "src/app/domain/enums/epi-type";
import { EExpositionClimatique } from "src/app/domain/enums/exposition-climatique";
import { EIntegriteType } from "src/app/domain/enums/integrite-type";
import { EMeteoType } from "src/app/domain/enums/meteo-type";
import { EMoyenObservation } from "src/app/domain/enums/moyen-observation";
import { EPostureType } from "src/app/domain/enums/posture-type";
import { ERoomUsage } from "src/app/domain/enums/room-usage";
import { ESamplingMode } from "src/app/domain/enums/sampling-mode";
import { ESubSection } from "src/app/domain/enums/subsection";
import { ETetePrelevement } from "src/app/domain/enums/tete-prelevement";
import { EVentilationGlobaleType } from "src/app/domain/enums/ventilation-global-type";
import { EContexteMesureLingette } from "src/app/domain/Lingette/enums/context-lingette";

export class StringConverter {

    static getConfirmMessageByLabel(label: string) {
        switch (label) {
            case 'confirm-removal-generic':
                return 'Etes-vous sûr de vouloir supprimer cet élément ?';
            case 'confirm-removal-strategy':
                return 'Etes-vous sûr de vouloir supprimer cette stratégie ?';
            default:
                return 'Not Set';
        }
    }

    static getTetePrelevementTypeName(type: ETetePrelevement) {
        switch (type) {
            case ETetePrelevement.Cathia:
                return 'Cathia';
            case ETetePrelevement.D37mm:
                return 'D37mm';
            case ETetePrelevement.Quales:
                return 'Quales';
            default:
                return 'Not Set';
        }
    }

    static getMeteoTypeName(type: EMeteoType) {
        switch (type) {
            case EMeteoType.Brumeux:
                return 'Brumeux';
            case EMeteoType.Neigeux:
                return 'Neigeux';
            case EMeteoType.Pluvieux:
                return 'Pluvieux';
            case EMeteoType.Sec:
                return 'Sec';
            default:
                return 'Not Set';
        }
    }

    static getEntreZoneTypeName(type: EEntreeZoneType) {
        switch (type) {
            case EEntreeZoneType.Oui:
                return 'Oui';
            case EEntreeZoneType.Non:
                return 'Non';
            case EEntreeZoneType.Sas:
                return 'Sas';
            case EEntreeZoneType.NA:
                return 'N/A';
            default:
                return 'Not Set';
        }
    }

    static getEntreProcessTypeName(type: EEntreeProcessType) {
        switch (type) {
            case EEntreeProcessType.ExtPerimetreChantier:
                return 'Ext - Dans le périmètre de chantier';
            case EEntreeProcessType.ExtSASUMD:
                return 'Ext - Dans les SAS de l\'UMD';
            case EEntreeProcessType.ExtZoneTraitement:
                return 'Ext - En zone de traitement';
            case EEntreeProcessType.IntZoneTraitement:
                return 'Int - En zone de traitement';
            case EEntreeProcessType.SAS:
                return 'Int - Dans les SAS';
            default:
                return 'Not Set';
        }
    }

    static getEPITypeName(type: EEPIType) {
        switch (type) {
            case EEPIType.AdductionFP250:
                return 'Adduction FP250';
            case EEPIType.Aucun:
                return 'Aucun';
            case EEPIType.DemiMasqueFP10:
                return 'Demi Masque FP10';
            case EEPIType.TM3PFP60:
                return 'TM3P FP60';
            default:
                return 'Not Set';
        }
    }

    static getBuildingTypeName(type: EBuildingType) {
        switch (type) {
            case EBuildingType.Business:
                return 'Commercial';
            case EBuildingType.Educational:
                return 'Enseignement';
            case EBuildingType.Healthcare:
                return 'Soin';
            case EBuildingType.Industrial:
                return 'Industriel';
            case EBuildingType.Leisure:
                return 'Loisir';
            case EBuildingType.Office:
                return 'Bureau';
            case EBuildingType.Other:
                return 'Autre';
            case EBuildingType.Residential:
                return 'Habitation';
            default:
                return 'Not Set';
        }
    }

    static getRoomUsageTypeName(type: ERoomUsage) {
        switch (type) {
            case ERoomUsage.Evacuated:
                return 'Local de vie évacué';
            case ERoomUsage.KeptInOperation:
                return 'Local de vie maintenu en activité';
            case ERoomUsage.LivingRoom:
                return 'Local de vie';
            case ERoomUsage.OccasionallyVisited:
                return 'Local occasionnellement visité';
            case ERoomUsage.NonConcerne:
                return 'Non Concerné'
            default:
                return 'Not Set';
        }
    }

    static getSubSectionName(type: ESubSection) {
        switch (type) {
            case ESubSection.SubSection3:
                return 'Sous-section 3';
            case ESubSection.SubSection4:
                return 'Sous-section 4';
            default:
                return 'Not Set';
        }
    }

    static getDustLoadTypeName(type: EDustLoadType) {
        switch (type) {
            case EDustLoadType.Low:
                return 'Faible';
            case EDustLoadType.Medium:
                return 'Moyen';
            case EDustLoadType.High:
                return 'Haut';
            default:
                return 'Not Set';
        }
    }

    static getCardinalityName(cardinality: ECardinality) {
        switch (cardinality) {
            case ECardinality.North:
                return '\u2191';
            case ECardinality.South:
                return '\u2193';
            case ECardinality.East:
                return '\u27f6';
            case ECardinality.West:
                return '\u2190';
            case ECardinality.NorthEast:
                return '\u2197';
            case ECardinality.NorthWest:
                return '\u2196';
            case ECardinality.SouthEast:
                return '\u2198';
            case ECardinality.SouthWest:
                return '\u2199';
            default:
                return 'Not Set';
        }
    }

    static getPostureTypeName(posture: EPostureType) {
        switch (posture) {
            case EPostureType.AGenoux:
                return 'A genoux';
            case EPostureType.Accroupi:
                return 'Accroupi';
            case EPostureType.Assis:
                return 'Assis';
            case EPostureType.Couche:
                return 'Couche';
            case EPostureType.DeboutBrasBas:
                return 'Debout Bras Bas';
            case EPostureType.DeboutBrasLeves:
                return 'Debout Bras Leves';
            default:
                return 'Not Set';
        }
    }

    static getActivitySimulationTypeName(type: EActivitySimulationType) {
        switch (type) {
            case EActivitySimulationType.MaintienEnSuspension:
                return 'Maintien en suspension';
            case EActivitySimulationType.RemiseEnSuspension:
                return 'Mise en suspension';
            case EActivitySimulationType.NC:
                return 'N/A';
            case EActivitySimulationType.Yes:
                return 'Mise et maintien en suspension';
            case EActivitySimulationType.No:
                return 'Non';
            case EActivitySimulationType.CirculationAirSuffisanteEtRepresentative:
                return 'Circulation d\'air suffisante et représentative';
            default:
                return 'Not Set';
        }
    }

    static getIntegriteTypeName(type: EIntegriteType) {
        switch (type) {
            case EIntegriteType.Oui:
                return 'Oui';
            case EIntegriteType.NonFiltreDechire:
                return 'Filtre déchire';
            case EIntegriteType.NonPoussieresNonAdherentes:
                return 'Poussieres non adhérentes';
            case EIntegriteType.NonPoussieresNonHomogenes:
                return 'Poussières non homogènes';
            case EIntegriteType.NonPresenceDeFixateur:
                return 'Présence de fixateur';
            case EIntegriteType.NonTracesHumidite:
                return 'Trâces humidité';
            default:
                return 'Not Set';
        }
    }

    static getAPRTypeName(type: EAPRType) {
        switch (type) {
            case EAPRType.AdductionAirALaDemande:
                return 'Adduction air à la demande';
            case EAPRType.AdductionAirDebitContinu:
                return 'Adduction air débit continu';
            case EAPRType.Aucun:
                return 'Aucun';
            case EAPRType.DemiMasqueP3:
                return 'Demi-masque P3';
            case EAPRType.FFP1:
                return 'FFP1';
            case EAPRType.FFP3:
                return 'FFP3';
            case EAPRType.P3Complet:
                return 'P3 Complet';
            case EAPRType.TM3P:
                return 'TM3P';
            case EAPRType.TenueEtancheVentilee:
                return 'Tenue étanche Ventilée';
            default:
                return 'Not Set';
        }
    }

    static getVentilationGlobaleTypeName(type: EVentilationGlobaleType) {
        switch (type) {
            case EVentilationGlobaleType.Absence:
                return 'Absence';
            case EVentilationGlobaleType.DispositifHorsFonction:
                return 'Dispositif hors-service';
            case EVentilationGlobaleType.GeneraleMecanique:
                return 'Generale mécanique';
            case EVentilationGlobaleType.RecycleurAir:
                return 'Recycleur air';
            default:
                return 'Not Set';
        }
    }

    static getSamplingModeName(mode: ESamplingMode) {
        switch (mode) {
            case ESamplingMode.Simultaneous:
                return 'Simultané';
            case ESamplingMode.Single:
                return 'Unique';
            case ESamplingMode.Successive:
                return 'Successif';
            case ESamplingMode.SuccessiveAndSimultaneous:
                return 'Successif et simultané';
            default:
                return 'Not Set';
        }
    }

    static getContexteMesureLingetteName(mode: EContexteMesureLingette) {
        switch (mode) {
            case EContexteMesureLingette.ControleEmpoussierementInitial:
                return 'Etat initial / Contrôle d’empoussièrement initial';
            case EContexteMesureLingette.ControleEmpoussierementHorsZoneIntervention:
                return 'Pendant travaux / Contrôle d’empoussièrement hors zone d’intervention.';
            case EContexteMesureLingette.ControleEmpoussierementExterieurChantier:
                return 'Pendant travaux / Contrôle d’empoussièrement à l’extérieur du chantier';
            case EContexteMesureLingette.ControleEmpoussierementApresNettoyage:
                return 'Fin de travaux / Contrôle d’empoussièrement après nettoyage';
            case EContexteMesureLingette.SurveillancePeriodique:
                return 'Surveillance périodique';
            default:
                return 'Not Set';
        }
    }
    static getLocalisationRejetName(mode: ELocalisationRejet) {
        switch (mode) {
            case ELocalisationRejet.Douche:
                return 'Douche';
            case ELocalisationRejet.SASMateriel:
                return 'SAS Matériel';
            case ELocalisationRejet.SASPerso:
                return 'SAS Perso';
            default:
                return 'Not Set';
        }
    }

    static getTypeMaterielName(mode: ETypeMateriel) {
        switch (mode) {
            case ETypeMateriel.SASPerso:
                return 'SAS Perso';
            case ETypeMateriel.UMD:
                return 'UMD';
            default:
                return 'Not Set';
        }
    }

    static getExpositionClimatiqueTypeName(exp: EExpositionClimatique) {
        switch (exp) {
            case EExpositionClimatique.Exterieur:
                return 'Extérieur';
            case EExpositionClimatique.Interieur:
                return 'Intérieur';
            case EExpositionClimatique.SemiOuvert:
                return 'Semi-ouvert';
            default:
                return 'Not Set';
        }
    }

    static getDegradationLevelName(exp: EDegradationLevel) {
        switch (exp) {
            case EDegradationLevel.BadState:
                return 'Mauvais état';
            case EDegradationLevel.Degraded:
                return 'Dégradé';
            case EDegradationLevel.Disbonding:
                return 'En décollement';
            case EDegradationLevel.GeneralDegradation:
                return 'Dégradation généralisée';
            case EDegradationLevel.GoodState:
                return 'Bon état';
            case EDegradationLevel.LocalDegradation:
                return 'Dégradation locale';
            case EDegradationLevel.NotAccessible:
                return 'Non accessible';
            case EDegradationLevel.NotCommunicated:
                return 'NC';
            case EDegradationLevel.NotDegraded:
                return 'Non dégradé';
            case EDegradationLevel.PartialDegradation:
                return 'Dégradation ponctuelle';
            case EDegradationLevel.CompleteProtection:
                return 'Protection complète';
            default:
                return 'Not Set';
        }
    }

    static getPrelevementAdductionName(type: ETypePrelevementAir) {

        switch (type) {
            case ETypePrelevementAir.BrouillardHuile:
                return 'Brouillard Huile';
            case ETypePrelevementAir.CO:
                return 'CO';
            case ETypePrelevementAir.CO2:
                return 'CO2';
            case ETypePrelevementAir.O2:
                return 'O2';
            case ETypePrelevementAir.TemperatureRosee:
                return 'Température Rosée'
            default:
                return 'Not Set';
        }
    }

    static getTypeMaterielAdductionAirName(type: ETypeMaterielAdductionAir) {

        switch (type) {
            case ETypeMaterielAdductionAir.Compresseur:
                return 'Compresseur';
            case ETypeMaterielAdductionAir.Cuve:
                return 'Cuve';
            case ETypeMaterielAdductionAir.SystemeDeFiltration:
                return 'Système de Filtration';
            default:
                return 'Not Set';
        }
    }

    static getMoyenObservationName(type: EMoyenObservation) {

        switch (type) {
            case EMoyenObservation.EnZoneDeTravail:
                return 'En zone de travail';
            case EMoyenObservation.BulleDeVision:
                return 'Bulle de vision';
            case EMoyenObservation.Camera:
                return 'Caméra';
            case EMoyenObservation.ExterieurDansLePerimetreDeChantier:
                return 'Extérieur dans le périmètre de chantier';
            default:
                return 'Not Set';
        }
    }
}